import styled from "styled-components";

interface PageProps {
  pageType: any,
}

export const Container = styled.div<PageProps>`
  margin-bottom: 2rem;
  position: relative;
  z-index: 1000;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;

  &.header-with-actions {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    min-width: 0;
  }

  &.header-with-actions .header-title-block {
    flex: 1 1 auto;
    min-width: 0;
  }

  &.header-with-actions h1 {
    margin: 0;
    min-width: 0;
  }

  &.header-with-actions .header-subtitle {
    width: 100%;
    margin: 4px 0 0;
    font-size: 0.875rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors?.interfaceTextGray ?? 'var(--c6b7280)'};
  }

  #planos-header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
    
    @media (max-width: 768px) {
      width: 100%;
      gap: 8px;
      /* Remove padding para alinhar com o conteúdo da página que já tem padding do Container */
      padding: 0;
      box-sizing: border-box;
      margin-left: 0;
      margin-right: 0;
    }
  }

  #planos-header-actions button {
    height: 40px !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    white-space: nowrap;
    flex-shrink: 0;
    width: auto !important;
    min-width: 0;
    
    @media (max-width: 768px) {
      flex: 1;
      min-width: 0;
      padding: 8px 10px !important;
      font-size: 13px !important;
    }
    
    @media (max-width: 420px) {
      padding: 8px 8px !important;
      font-size: 12px !important;
    }
  }

  #planos-header-actions .icon + .children,
  #planos-header-actions .children {
    white-space: nowrap;
  }

  .back {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    position: relative;
    z-index: 1003;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.interfaceTextGray};
      }
    }
  }

  h1 {
    font-size: ${({ pageType }) => pageType === 'special' ? '2.5rem' : '1.5rem'};
    font-weight: ${({ pageType }) => pageType === 'special' ? '400' : '500'};
    color: ${({ theme }) => theme.colors.interfaceText400};
    text-transform: capitalize;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

  }

  @media (max-width: 768px) {
    /* Padding para evitar sobreposição com botão hamburger da sidebar */
    padding-left: 56px;
    box-sizing: border-box;
  }

  @media (max-width: 740px) {
    h1 {
      font-size: ${({ pageType }) => pageType === 'special' ? '1.75rem' : '1.25rem'};
    }
    
    .back {
      margin-left: 35px;
      z-index: 1003;
    }
    
    /* Header com actions não deve ter margin-left no mobile */
    &.header-with-actions {
      margin-left: 0;
    }
    
    /* Apenas h1 fora do header-with-actions recebe margin */
    &:not(.header-with-actions) {
      margin-left: 35px;
    }
  }

  @media (max-width: 1000px) {
      width: 100%;
  }
`;
